define('baseline/hotkeys',["require", "exports", "../charts/dataseries"], function (require, exports, dataseries) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init() {
        document.addEventListener("keyup", function (evnt) {
            // Check if key matches series hotkey
            for (var _i = 0, _a = dataseries.all; _i < _a.length; _i++) {
                var options = _a[_i];
                if (options.hotkey === evnt.key.toLowerCase()) {
                    // Enable/disable data series
                    options.enabled = !options.enabled;
                    dataseries.seriesUpdates.post(options);
                }
            }
        });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/baseline/hotkeys.js.map;
